import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const isMobile = () => {
  if (screen.width <= 760) {
    return true;
  } else {
    return false;
  }
};

const routes: Array<RouteConfig> = [
  {
    path: "/",
    redirect: { name: "shifts" },
  },

  {
    meta: {
      title: "Склады",
    },
    path: "/warehouses",
    name: "warehouses-list",
    component: () =>
      import(
        /* webpackChunkName: "WarehousesList" */
        "../modules/WarehousesList/WarehousesList.vue"
      ),
  },
  {
    meta: {
      title: "Склады: производство",
    },
    path: "/warehouses-internal",
    name: "warehouses-internal-list",
    component: () =>
      import(
        /* webpackChunkName: "WarehousesInternalList" */
        "../modules/WarehousesInternalList/WarehousesInternalList.vue"
      ),
  },
  {
    meta: {
      title: "Склады: производство",
    },
    path: "/warehouses-done",
    name: "warehouses-done-list",
    component: () =>
      import(
        /* webpackChunkName: "WarehousesDoneList" */
        "../modules/WarehousesDoneList/WarehousesDoneList.vue"
      ),
  },
  {
    meta: {
      title: "Склады неготовой продукции",
    },
    path: "/warehouses-unfinished",
    name: "warehouses-unfinished-list",
    component: () =>
      import(
        /* webpackChunkName: "WarehousesUnfinishedList" */
        "../modules/WarehousesUnfinishedList/WarehousesUnfinishedList.vue"
      ),
  },
  {
    meta: {
      title: "Склад утилизаци",
    },
    path: "/warehouses-utilization",
    name: "warehouses-utilization-list",
    component: () =>
      import(
        /* webpackChunkName: "WarehousesUtilizationList" */
        "../modules/WarehousesUtilizationList/WarehousesUtilizationList.vue"
      ),
  },
  {
    meta: {
      title: "Склад карантина",
    },
    path: "/warehouses-carantine",
    name: "warehouses-carantine-list",
    component: () =>
      import(
        /* webpackChunkName: "WarehousesCarantineList" */
        "../modules/WarehousesCarantineList/WarehousesCarantineList.vue"
      ),
  },
  {
    meta: {
      title: "Склад переработки",
    },
    path: "/warehouses-recycling",
    name: "warehouses-recycling-list",
    component: () =>
      import(
        /* webpackChunkName: "WarehousesRecyclingList" */
        "../modules/WarehousesRecyclingList/WarehousesRecyclingList.vue"
      ),
  },
  {
    meta: {
      title: "Склад готовой продукции",
    },
    path: "/warehouses",
    name: "warehouses-list",
    component: () =>
      import(
        /* webpackChunkName: "WarehousesUnfinishedList" */
        "../modules/WarehousesUnfinishedList/WarehousesUnfinishedList.vue"
      ),
  },
  {
    meta: {
      title: "Расхождения остатков",
    },
    path: "/warehouses-resort",
    name: "warehouses-resort-list",
    component: () =>
      import(
        /* webpackChunkName: "WarehousesList" */
        "../modules/WarehousesList/WarehouseResortList/WarehouseResortList.vue"
      ),
  },
  {
    meta: {
      title: "Подтвеждение доставки",
    },
    path: "/warehouses-delivery-approve",
    name: "warehouses-delivery-approve-list",
    component: () =>
      import(
        /* webpackChunkName: "WarehousesList" */
        "../modules/WarehousesList/WarehouseDeliveryApproveList/WarehouseDeliveryApproveList.vue"
      ),
  },

  {
    meta: {
      title: "Отчет по результатам ПП",
    },
    path: "/reports/result-pp",
    name: "result-pp",
    component: () =>
      import(
        /* webpackChunkName: "ResultPPReport" */
        "../modules/Reports/ResultPPReport/ResultPPReport.vue"
      ),
  },

  {
    meta: {
      title: "Отчет по количественному отклонению",
    },
    path: "/reports/deviant",
    name: "deviant",
    component: () =>
      import(
        /* webpackChunkName: "DeviantReport" */
        "../modules/Reports/DeviantReport/DeviantReport.vue"
      ),
  },

  {
    meta: {
      title: "Отчет мойкам",
    },
    path: "/reports/washings",
    name: "washings",
    component: () =>
      import(
        /* webpackChunkName: "WashingsReport" */
        "../modules/Reports/WashingsReport/WashingsReport.vue"
      ),
  },

  {
    meta: {
      title: "Отчет активности",
    },
    path: "/reports/activity",
    name: "activity",
    component: () =>
      import(
        /* webpackChunkName: "Activity" */
        "../modules/Reports/Activity/Activity.vue"
      ),
  },

  {
    meta: {
      title: "Отчет по выгрузке",
    },
    path: "/reports/export-to-crm",
    name: "export-to-crm",
    component: () =>
      import(
        /* webpackChunkName: "ExportToCrmReport" */
        "../modules/Reports/ExportToCrmReport/ExportToCrmReport.vue"
      ),
  },

  {
    meta: {
      title: "Отчет потерям АТОМ",
    },
    path: "/reports/losses",
    name: "losses",
    component: () =>
      import(
        /* webpackChunkName: "LossesReport" */
        "../modules/Reports/LossesReport/LossesReport.vue"
      ),
  },

  {
    meta: {
      title: "Отчет по лаборатории",
    },
    path: "/reports/laboratory",
    name: "laboratory",
    component: () =>
      import(
        /* webpackChunkName: "LaboratoryReport" */
        "../modules/Reports/LaboratoryReport/LaboratoryReport.vue"
      ),
  },

  // ////////////////////////////////////////////////////////////////////////
  // PRODUCE PART
  // ////////////////////////////////////////////////////////////////////////

  {
    meta: {
      title: "Смена",
    },
    path: "/shifts/",
    name: "shifts",
    component: () =>
      import(
        /* webpackChunkName: "ShiftsList" */
        "../modules/ShiftsList/ShiftsList.vue"
      ),
  },
  {
    meta: {
      title: "Редактирование смены",
    },
    path: "/shifts/details/:id",
    name: "shift-details",
    component: () =>
      import(
        /* webpackChunkName: "ShiftDetails" */
        "../modules/ShiftDetails/ShiftDetails.vue"
      ),
    // beforeEnter: (to, from, next) => {
    //   const twModalView = from.matched.length > 0 //.some(view => view.meta && view.meta.twModalView)

    //   if (!twModalView) {
    //     //
    //     // For direct access
    //     //
    //     to.matched[0].components = {
    //       default: () => import(
    //         /* webpackChunkName: "ShiftDetails" */
    //         '../modules/ShiftDetails/ShiftDetails.vue'
    //       ),
    //       // @ts-ignore
    //       modal: false
    //     }
    //   }

    //   if (twModalView) {

    //     // For twModalView access
    //     //
    //     if (from.matched.length > 1) {
    //       // copy nested router
    //       const childrenView = from.matched.slice(1, from.matched.length)

    //       for (const view of childrenView) {
    //         to.matched.push(view)
    //       }
    //     }

    //     if (to.matched[0].components) {
    //       // Rewrite components for `default`
    //       to.matched[0].components.default = from.matched[0].components.default
    //       // Rewrite components for `modal`
    //       to.matched[0].components.modal = () => import(
    //         /* webpackChunkName: "ShiftDetailsProxy" */
    //         '../modules/ShiftDetails/ShiftDetailsProxy.vue'
    //       )
    //     }
    //   }

    //   next()
    // }
  },

  {
    meta: {
      title: "Словарь: Роли",
    },
    path: "/vocs/roles",
    name: "roles-manager",
    component: () =>
      import(
        /* webpackChunkName: "RolesManager" */
        "../modules/Vocabularies/RolesManager/RolesManager.vue"
      ),
  },

  {
    meta: {
      title: "Словарь: Типы закваски",
    },
    path: "/vocs/starter-types",
    name: "starter-types-manager",
    component: () =>
      import(
        /* webpackChunkName: "StarterTypeManager" */
        "../modules/Vocabularies/StarterTypeManager/StarterTypeManager.vue"
      ),
  },
  {
    meta: {
      title: "Ингридиенты",
    },
    path: "/ingredients",
    name: "ingredients-manager",
    component: () =>
      import(
        /* webpackChunkName: "IngredientsManager" */
        "../modules/IngredientsManager/IngredientsManager.vue"
      ),
  },
  {
    meta: {
      title: "Рецептуры",
    },
    path: "/prescripts",
    name: "prescript-manager",
    component: () =>
      import(
        /* webpackChunkName: "prescriptManager" */
        "../modules/PrescriptManager/PrescriptManager.vue"
      ),
  },

  {
    meta: {
      title: "Словарь: Выпуск ГП",
    },
    path: "/vocs/release-gps",
    name: "release-gps-manager",
    component: () =>
      import(
        /* webpackChunkName: "ReleaseGPsManager" */
        "../modules/Vocabularies/ReleaseGPsManager/ReleaseGPsManager.vue"
      ),
  },

  {
    meta: {
      title: "Словарь: Качество ПП при загрузке",
    },
    path: "/vocs/quality_pps",
    name: "quality-pps-manager",
    component: () =>
      import(
        /* webpackChunkName: "QualityPPsManager" */
        "../modules/Vocabularies/QualityPPsManager/QualityPPsManager.vue"
      ),
  },

  {
    meta: {
      title: "Словарь: Густота продукта во время варки",
    },
    path: "/vocs/densities",
    name: "densities-manager",

    component: () =>
      import(
        /* webpackChunkName: "DensitiesManager" */
        "../modules/Vocabularies/DensitiesManager/DensitiesManager.vue"
      ),
  },

  {
    meta: {
      title: "Словарь: Консистенция продукта на розливе",
    },
    path: "/vocs/consistensies",
    name: "consistensies-manager",
    component: () =>
      import(
        /* webpackChunkName: "ConsistensiesManager" */
        "../modules/Vocabularies/ConsistensiesManager/ConsistensiesManager.vue"
      ),
  },

  {
    meta: {
      title: "Словарь: поставщики",
    },
    path: "/vocs/providers",
    name: "providers-manager",
    component: () =>
      import(
        /* webpackChunkName: "ProvidersManager" */
        "../modules/Vocabularies/ProvidersManager/ProvidersManager.vue"
      ),
  },

  {
    meta: {
      title: "Оборудование",
      type: "equipment",
    },
    path: "/equipment",
    name: "equipment-manager",
    component: () =>
      import(
        /* webpackChunkName: "VolumeManager" */
        "../modules/VolumeManager/VolumeManager.vue"
      ),
  },
  {
    meta: {
      title: "Емкость для сквашивания",
      type: "volume",
    },
    path: "/vocs/volume",
    name: "volume-manager",
    component: () =>
      import(
        /* webpackChunkName: "VolumeManager" */
        "../modules/VolumeManager/VolumeManager.vue"
      ),
  },

  {
    meta: {
      title: "Мойки",
    },
    path: "/watching",
    name: "watching-list",
    component: () =>
      import(
        /* webpackChunkName: "WashingList" */
        "../modules/WashingList/WashingList.vue"
      ),
  },

  {
    meta: {
      title: "Производственные линии",
    },
    path: "/lines",
    name: "lines-manager",
    component: () =>
      import(
        /* webpackChunkName: "LinesManager" */
        "../modules/LinesManager/LinesManager.vue"
      ),
  },
  {
    meta: {
      title: "Партии сырья",
    },
    path: "/batches",
    name: "batches-manager",
    component: () =>
      import(
        /* webpackChunkName: "BatchesManager" */
        "../modules/BatchesManager/BatchesManager.vue"
      ),
  },
  {
    meta: {
      title: "Редактирование линии",
    },
    path: "/lines/details/:id",
    name: "lines-details",
    beforeEnter: (to, from, next) => {
      const twModalView = from.matched.length > 0; //.some(view => view.meta && view.meta.twModalView)

      if (!twModalView) {
        //
        // For direct access
        //
        to.matched[0].components = {
          default: () =>
            import(
              /* webpackChunkName: "LinesDetails" */
              "../modules/LinesDetails/LinesDetails.vue"
            ),
          // @ts-ignore
          modal: false,
        };
      }

      if (twModalView) {
        //
        // For twModalView access
        //
        if (from.matched.length > 1) {
          // copy nested router
          const childrenView = from.matched.slice(1, from.matched.length);

          for (const view of childrenView) {
            to.matched.push(view);
          }
        }

        if (to.matched[0].components) {
          // Rewrite components for `default`
          to.matched[0].components.default = from.matched[0].components.default;
          // Rewrite components for `modal`
          to.matched[0].components.modal = () =>
            import(
              /* webpackChunkName: "LinesDetailsProxy" */
              "../modules/LinesDetails/LinesDetailsProxy.vue"
            );
        }
      }

      next();
    },
  },

  {
    meta: {
      title: "Словарь: Причины закрытия",
    },
    path: "/vocs/reasons",
    name: "reasons-manager",
    component: () =>
      import(
        /* webpackChunkName: "ReasonsManager" */
        "../modules/Vocabularies/ReasonsManager/ReasonsManager.vue"
      ),
  },

  {
    meta: {
      title: "Словарь: Тары",
    },
    path: "/vocs/containers",
    name: "containers-manager",
    component: () =>
      import(
        /* webpackChunkName: "ContainersManager" */
        "../modules/Vocabularies/ContainersManager/ContainersManager.vue"
      ),
  },

  {
    meta: {
      title: "Рецептуры",
    },
    path: "/bases",
    name: "bases-list",
    component: () =>
      import(
        /* webpackChunkName: "BasesManager" */
        "../modules/BasesManager/BasesManager.vue"
      ),
  },

  {
    meta: {
      title: "Редактирование рецепутры",
    },
    path: "/bases/details/:id",
    name: "bases-details",
    component: () =>
      import(
        /* webpackChunkName: "BasesManagerForm" */
        "@/modules/BasesDetails/BasesManagerForm.vue"
      ),
  },

  {
    meta: {
      title: "Словарь: Места хранения",
    },
    path: "/vocs/storages",
    name: "storages-manager",
    component: () =>
      import(
        /* webpackChunkName: "StoragesManager" */
        "../modules/Vocabularies/StoragesManager/StoragesManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Степень упругости",
      table: "voc_elasticities",
      name: "Степень упругости",
    },
    path: "/vocs/elasticity",
    name: "elasticity-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: инциденты",
      table: "voc_incidents",
      name: "Инциденты",
    },
    path: "/vocs/incidents",
    name: "incidents-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: способы утилизации",
      table: "voc_disposals",
      name: "Способы утилизации",
    },
    path: "/vocs/disposals",
    name: "disposals-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Глубина колкости",
    },
    path: "/vocs/causticity",
    name: "causticity-manager",
    component: () =>
      import(
        /* webpackChunkName: "CausticityManager" */
        "../modules/Vocabularies/CausticityManager/CausticityManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Корректоры",
    },
    path: "/vocs/corrector",
    name: "corrector-manager",
    component: () =>
      import(
        /* webpackChunkName: "CorrectorManager" */
        "../modules/Vocabularies/CorrectorManager/CorrectorManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Регулятор",
    },
    path: "/vocs/regulator",
    name: "regulator-manager",
    component: () =>
      import(
        /* webpackChunkName: "RegulatorManager" */
        "../modules/Vocabularies/RegulatorManager/RegulatorManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Логотипы",
    },
    path: "/vocs/logo",
    name: "logo-manager",
    component: () =>
      import(
        /* webpackChunkName: "LogoManager" */
        "../modules/Vocabularies/LogoManager/LogoManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Активность",
    },
    path: "/vocs/activity",
    name: "activity-manager",
    component: () =>
      import(
        /* webpackChunkName: "ActivityManager" */
        "../modules/Vocabularies/ActivityManager/ActivityManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Ротации",
    },
    path: "/vocs/rotates",
    name: "rotates-manager",
    component: () =>
      import(
        /* webpackChunkName: "RotatesManager" */
        "../modules/Vocabularies/RotatesManager/RotatesManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Количество сухой закваски",
    },
    path: "/vocs/dry-caucity",
    name: "dry-caucity-manager",
    component: () =>
      import(
        /* webpackChunkName: "DryCaucityManager" */
        "../modules/Vocabularies/DryCaucityManager/DryCaucityManager.vue"
      ),
  },

  {
    meta: {
      title: "Словарь: Размешиваемость в термомиксе",
      table: "voc_elasticities",
      name: "Размешиваемость в термомиксе",
    },
    path: "/vocs/warehouses",
    name: "warehouses-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },

  {
    meta: {
      title: "Калькулятор",
    },
    path: "/calculator",
    name: "calculator",
    component: () =>
      import(
        /* webpackChunkName: "Calculator" */
        "../modules/Calculator/Calculator.vue"
      ),
  },

  {
    meta: {
      title: "Продукры производства",
    },
    path: "/produced-product",
    name: "produced-product",
    component: () =>
      import(
        /* webpackChunkName: "ProducedProduct" */
        "../modules/ProducedProduct/ProducedProduct.vue"
      ),
  },

  {
    meta: {
      title: "Словарь: Заказ-наряд",
      table: "voc_work_orders",
      name: "Заказ-наряд",
      ignore_fields: ["quarantine", "recycling", "position"],
    },
    path: "/vocs/work_orders",
    name: "work_orders-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Размешиваемость в термомиксе",
      table: "voc_stirability_thermomix",
      name: "Размешиваемость в термомиксе	",
    },
    path: "/vocs/stirability_thermomix",
    name: "stirability_thermomix-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Блеск в термомиксе",
      table: "voc_glitter_thermomix",
      name: "Блеск в термомиксе	",
    },
    path: "/vocs/glitter_thermomix",
    name: "glitter_thermomix-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Термостабильность (микроволновка)",
      table: "voc_thermal_stability",
      name: "Термостабильность (микроволновка)	",
    },
    path: "/vocs/thermal_stability",
    name: "thermal_stability-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Термоустойчивость (шарик)",
      table: "voc_heat_resistance",
      name: "Термоустойчивость (шарик)	",
    },
    path: "/vocs/heat_resistance",
    name: "heat_resistance-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Твердость",
      table: "voc_hardness",
      name: "Твердость	",
    },
    path: "/vocs/hardness",
    name: "hardness-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Колкость при первичном откалывании",
      table: "voc_causticity_initial_spalling",
      name: "Колкость при первичном откалывании	",
    },
    path: "/vocs/causticity_initial_spalling",
    name: "causticity_initial_spalling-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Пластичность (эффект масличка)",
      table: "voc_plasticity",
      name: "Пластичность (эффект масличка)	",
    },
    path: "/vocs/plasticity",
    name: "plasticity-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Плотность / Рыхлость",
      table: "voc_looseness",
      name: "Плотность / Рыхлость	",
    },
    path: "/vocs/looseness",
    name: "looseness-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Звук откола продукта лопаткой от общей массы",
      table: "voc_sound_product_breaking",
      name: "Звук откола продукта лопаткой от общей массы	",
    },
    path: "/vocs/sound_product_breaking",
    name: "sound_product_breaking-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Звук при развозюкивании продукта",
      table: "voc_sound_product_released",
      name: "Звук при развозюкивании продукта	",
    },
    path: "/vocs/sound_product_released",
    name: "sound_product_released-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Ощущение текстуры во рту",
      table: "voc_feeling_of_texture",
      name: "Ощущение текстуры во рту	",
    },
    path: "/vocs/feeling_of_texture",
    name: "feeling_of_texture-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: 'Словарь: Скорость растворения во рту (эффект "пух")',
      table: "voc_fluff_effect",
      name: 'Скорость растворения во рту (эффект "пух")',
    },
    path: "/vocs/fluff_effect",
    name: "fluff_effect-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Кислинка",
      table: "voc_kislinka",
      name: "Кислинка	",
    },
    path: "/vocs/kislinka",
    name: "kislinka-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Сербский профиль",
      table: "voc_serbian_profile",
      name: "Сербский профиль	",
    },
    path: "/vocs/serbian_profile",
    name: "serbian_profile-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Сладость",
      table: "voc_sweetness",
      name: "Сладость	",
    },
    path: "/vocs/sweetness",
    name: "sweetness-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Соленость",
      table: "voc_salinity",
      name: "Соленость	",
    },
    path: "/vocs/salinity",
    name: "salinity-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Пороки вкуса",
      table: "voc_vices",
      name: "Пороки вкуса",
    },
    path: "/vocs/vices",
    name: "vices-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Виды сырья",
      table: "voc_raw_materials",
      name: "Виды сырья",
      ignore_fields: ["quarantine", "recycling"],
    },
    path: "/vocs/raw_materials",
    name: "raw-materials-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Типы моек",
      table: "voc_washing_types",
      name: "Типы моек",
      ignore_fields: ["quarantine", "recycling", "color", "position"],
    },
    path: "/vocs/washing_types",
    name: "washing-types-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Моющие средства",
      table: "voc_detergents",
      name: "Моющие средства",
      ignore_fields: ["quarantine", "recycling", "color", "position"],
    },
    path: "/vocs/detergents",
    name: "detergents-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Производители моющего средства",
      table: "voc_manufacturers_detergent",
      name: "Производители моющего средства",
      ignore_fields: ["quarantine", "recycling", "color", "position"],
    },
    path: "/vocs/manufacturers-detergent",
    name: "manufacturers-detergent-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Подгруппы",
      table: "voc_subgroups",
      name: "Подгруппы",
      ignore_fields: ["quarantine", "recycling"],
    },
    path: "/vocs/subgroups",
    name: "subgroups-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Производители сырья",
      table: "voc_manufacturers",
      name: "Производители сырья",
      ignore_fields: ["quarantine", "recycling"],
    },
    path: "/vocs/manufacturers",
    name: "manufacturers-manager",
    component: () =>
      import(
        /* webpackChunkName: "VocabularyManager" */
        "../modules/Vocabularies/VocabularyManager/VocabularyManager.vue"
      ),
  },
  {
    meta: {
      title: "Словарь: Причины перевода между складами",
    },
    path: "/vocs/warehouse-transit-types",
    name: "warehouse-transit-types",
    component: () =>
      import(
        /* webpackChunkName: "WarehouseTransitTypes" */
        "../modules/Vocabularies/WarehouseTransitTypes/WarehouseTransitTypes.vue"
      ),
  },
  {
    meta: {
      title: "Настройки",
    },
    path: "/settings",
    name: "settings",
    component: () =>
      import(
        /* webpackChunkName: "Settings" */
        "../modules/Settings/Settings.vue"
      ),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "is-active",
  routes,
});

import store from "../store";

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.title) {
    window.document.title = `${to.meta.title} | Русбиомикс: система управления`;
    if (to.meta.name) {
      to.params.name = to.meta.name;
      to.params.table = to.meta.table;
      to.params.ignore_fields = to.meta.ignore_fields;
    }
  }

  store.commit("hideSubmenu");

  next();
});

export default router;
